export interface IAppSettings {
  defaultLocale: string;
  supportedLocales: string[];
  isSystemOnline: string;
  closeConversations: { status: string; time: number };
}
